export class CPFValidate {
  private static readonly cpfSizeWithoutDV: number = 9;
  private static readonly regexCPFWithoutDV: RegExp = /^([\d]){9}$/;
  private static readonly regexCPF: RegExp = /^([\d]){9}(\d){2}$/;
  private static readonly regexCharactersMask: RegExp = /[./-]/g;
  private static readonly regexCharactersNotAllowed: RegExp = /[^\d./-]/i;
  private static readonly dvWeights: number[] = [
    11, 10, 9, 8, 7, 6, 5, 4, 3, 2,
  ];
  private static readonly cpfZeroed: string = "00000000000";

  static isValid(cpf: string): boolean {
    if (!this.regexCharactersNotAllowed.test(cpf)) {
      let cpfWithoutMask = this.removeCPFMask(cpf);
      if (
        this.regexCPF.test(cpfWithoutMask) &&
        cpfWithoutMask !== CPFValidate.cpfZeroed
      ) {
        const dvInformed = cpfWithoutMask.substring(this.cpfSizeWithoutDV);
        const dvCalculate = this.calculateDV(
          cpfWithoutMask.substring(0, this.cpfSizeWithoutDV),
        );
        return dvInformed === dvCalculate;
      }
    }
    return false;
  }

  static calculateDV(cpf: string): string {
    if (!this.regexCharactersNotAllowed.test(cpf)) {
      let cpfWithoutMask = this.removeCPFMask(cpf);
      if (
        this.regexCPFWithoutDV.test(cpfWithoutMask) &&
        cpfWithoutMask !== this.cpfZeroed.substring(0, this.cpfSizeWithoutDV)
      ) {
        let sumDV1 = 0;
        let sumDV2 = 0;
        for (let i = 0; i < this.cpfSizeWithoutDV; i++) {
          sumDV1 += Number(cpfWithoutMask.charAt(i)) * this.dvWeights[i + 1];
          sumDV2 += Number(cpfWithoutMask.charAt(i)) * this.dvWeights[i];
        }
        const remainderDV1 = sumDV1 % 11;
        const dv1 = remainderDV1 < 2 ? 0 : 11 - remainderDV1;
        sumDV2 += dv1 * this.dvWeights[this.cpfSizeWithoutDV];
        const remainderDV2 = sumDV2 % 11;
        const dv2 = remainderDV2 < 2 ? 0 : 11 - remainderDV2;
        return `${dv1}${dv2}`;
      }
    }
    throw new Error(
      "Não é possível calcular o DV pois o CPF fornecido é inválido",
    );
  }

  private static removeCPFMask(cpf: string): string {
    return cpf.replace(this.regexCharactersMask, "");
  }
}
